import React, { FC, InputHTMLAttributes, useState, useEffect, ReactNode, useRef } from 'react'
import StandardInput, { StandardInputProps } from 'src/components/basic/StandardInput'



interface BarCardNumberInputProps extends InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  value: string;
  isOutsideTexas?: boolean;
  isIncorrect?: boolean;
  errorMessage?: ReactNode;
  label?: ReactNode;
  errorCode?: string;
}

const BarCardNumberInput: FC<BarCardNumberInputProps> = ({
  value,
  label,
  isOutsideTexas = false,
  errorCode = '',
  ...props
}: BarCardNumberInputProps) => {
  const [barCardNumberHasBlurred, setBarCardNumberHasBlurred] = useState(false);

  const ref = useRef<HTMLInputElement>();

  function handleBarCardNumberBlur() {
    setBarCardNumberHasBlurred(true);
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    //implement a maximum length validation which normally doesn't exist when input type = number
    if (!props.onChange) { return false; }
    if (e.currentTarget.value.length > 8 && !isOutsideTexas) {
      return props.onChange({
        ...e,
        target: {
          ...e.target,
          value:
            e.currentTarget.value.slice(0, 8)
        }
      });
    }

    if (e.currentTarget.value.length > 20 && isOutsideTexas) {
      return props.onChange({
        ...e,
        target: {
          ...e.target,
          value:
            e.currentTarget.value.slice(0, 20)
        }
      });
    }

    props.onChange(e);
  }

  function isBarCardNumberIncorrect() {
    const length = value.length;
    if (!length && !barCardNumberHasBlurred) {
      return false; //user hasn't had a chance to populate it
    }
    if (length && !isOutsideTexas) {
      return !(length == 6 || length == 8);
    }
    return false;
  }

  function decideBarCardNumberErrorMessage() {
    const length = value.length;
    if (isBarCardNumberIncorrect()) {
      if (!(length == 6 || length == 8) && !isOutsideTexas) {
        return "Bar Card Number must be 6 or 8 digits. If the attorney is only licensed outside the state of Texas, use trailing 0's to meet the 6 or 8 digit requirement";
      }
    }
    if (barCardNumberHasBlurred && !length) {
      return 'This is a required field';
    }
    return '';
  }

  return StandardInput({
    ...props,
    value,
    type: isOutsideTexas ? 'text' : 'number',
    label: (label ? label : <span>Bar Card Number</span>),
    isIncorrect: isBarCardNumberIncorrect(),
    errorMessage: decideBarCardNumberErrorMessage(),
    onChange: handleChange,
    handleBlur: handleBarCardNumberBlur,
    errorCode: errorCode,

  });
}

export default BarCardNumberInput;